module.exports = __webpack_public_path__ + "img/table.1fe55305.svg";